import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import IntlProvider from '../../common/utils/IntlProvider';
import messages from './messages';
const RecaptchaTermsAndPolicy = ({
  tagName = 'span'
}) => /*#__PURE__*/React.createElement(IntlProvider, null, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.termsAndPolicy, {
  tagName: tagName,
  values: {
    privacyPolicy: /*#__PURE__*/React.createElement("a", {
      href: "https://policies.google.com/privacy",
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/React.createElement(FormattedMessage, messages.privacyPolicy)),
    termsOfService: /*#__PURE__*/React.createElement("a", {
      href: "https://policies.google.com/terms",
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/React.createElement(FormattedMessage, messages.termsOfService))
  }
})));
export default RecaptchaTermsAndPolicy;